import { render, staticRenderFns } from "./setting-financial-bank.html?vue&type=template&id=90fb01ec&scoped=true&"
import script from "./setting-financial-bank.js?vue&type=script&lang=js&"
export * from "./setting-financial-bank.js?vue&type=script&lang=js&"
import style0 from "./setting-financial-bank.scss?vue&type=style&index=0&id=90fb01ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fb01ec",
  null
  
)

export default component.exports